export default __webpack_public_path__ + "static/media/walkThrough003.e93255bb.png";